import { Col, DatePicker, Form } from "antd";

const MarinaCoverNoteFilter = () => {
  return (
    <>
      <Col span={4}>
        <Form.Item name="from_date" label="From Date">
          <DatePicker
            style={{ width: "100%" }}
            format="YYYY-MM-DD"
            placeholder="Select from date"
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item name="to_date" label="To Date">
          <DatePicker
            style={{ width: "100%" }}
            format="YYYY-MM-DD"
            placeholder="Select to date"
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default MarinaCoverNoteFilter;
